module.exports = __webpack_public_path__ + "dfecb7f2e410b48df163ccc572e85091.svg";